export function times(length, callback) {
    var result = [];
    for(var i = 0; i < length; i = i + 1){
        result.push(callback(i));
    }
    return result;
}
